import { render, staticRenderFns } from "./MoleculeAccordion.vue?vue&type=template&id=2af44066&"
import script from "./MoleculeAccordion.vue?vue&type=script&lang=ts&"
export * from "./MoleculeAccordion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports